module.exports = __webpack_public_path__ + "static/media/horse_on_window.1cf62eb6.png";